/**
 * Route configuration for hero theme management.
 * Controls navbar and initial page background based on route.
 */

export type HeroTheme = "dark" | "light";

/**
 * Routes with dark hero sections.
 * These pages will have a dark navbar and dark initial background.
 */
export const DARK_HERO_PATHS = ["/about", "/blog", "/contact", "/portfolio"];

/**
 * Route prefixes for dynamic routes with dark heroes.
 * e.g., /blog/some-post will match /blog/ prefix
 */
export const DARK_HERO_PREFIXES = ["/blog/", "/design-lab/"];

/**
 * Get the hero theme for a given pathname.
 * Used by both the blocking script and the navbar.
 */
export function getHeroTheme(pathname: string): HeroTheme {
	// Exact match
	if (DARK_HERO_PATHS.includes(pathname)) {
		return "dark";
	}

	// Prefix match for dynamic routes
	if (DARK_HERO_PREFIXES.some((prefix) => pathname.startsWith(prefix))) {
		return "dark";
	}

	return "light";
}
